import { getgclidAPI } from "../../api/index"
export const substringFun = (fullUrl) => {
    let index = fullUrl.indexOf('gclid');
    let result = '';
    if (index !== -1) {
        result = fullUrl.substring(index + 6); // 从找到的字符后面第三位开始截取
        console.log("-----------", result);
    } else {
        console.log("字符未找到");
    }
    return result;
}
export const gclid = (data) => {
    setTimeout(() => {
        getgclidAPI({ 'gclid': data }).then(res => {
            console.log("res", res);
        })
    }, 500);
}
export const getCookie = (name) => {
    let nameEQ = name + "=";
    let ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}
export const goWhatsApp = (name) => {
    const pathname = window.location.pathname;
    const currentHref = window.location.href;
    const referrer = window.document.referrer;
    const url = 'https://www.sino-bus.com/google_ads/openapi/get_config';
    const data = new FormData();
    data.append('href', currentHref);
    data.append('referrer', referrer);
    if (getCookie(pathname)) {

        window.location.href = name ? getCookie(pathname) + name : getCookie(pathname);
    } else {
        fetch(url, {
            method: 'POST',
            body: data
        })
            .then(response => response.json())
            .then(data => {
                let whatsUrl = ''
                if (data.code === 0) {
                    if (name) {
                        whatsUrl = data.data.whats_app + name;
                    } else {
                        whatsUrl = data.data.whats_app;
                    }
                    window.location.href = whatsUrl;
                    document.cookie = `${pathname}=${data.data.whats_app}`;
                } else {
                    alert(data.message);
                }
            })
            .catch(error => {
                console.error('Error:', error);
                alert(error);
            });
    }
}
